export default [

     {
          path: '/tag',
          name: 'Tag',
          component: () => import("@/views/Page/Tag/Tag.vue"),
           meta: {
               title: '#Default# | Tag',
          },
     }
];